<template>
<Login/>
</template>

<script >
import Login from "../pages/user/Login.vue";

export default {
  components: {
     Login
  },
};

</script>